// "Compare Insurance Rates" intro band (STATIC, code-managed).
export default function HomeF2() {
    return (
        <div className="sec-compare">
            <h2 className="sec-compare-heading">Compare Insurance Rates with <br /> GM Insurance Services</h2>
            <p className="sec-para" style={{ maxWidth: "820px" }}>
                GM Insurance Services is a California-based insurance agency helping individuals, families, and
                businesses find affordable insurance coverage. We work with multiple insurance carriers to help
                customers compare rates, review coverage options, and choose insurance that makes sense for their
                situation.
            </p>
            <p className="sec-para" style={{ maxWidth: "820px" }}>
                Whether you are shopping for cheap car insurance, commercial auto insurance, trucking insurance,
                business insurance, general liability, workers compensation, homeowners insurance, or earthquake
                insurance, GM Insurance Services is here to help.
            </p>
            <p className="sec-para" style={{ fontWeight: 600, marginTop: "1.5em", maxWidth: "820px" }}>
                Call <a href="tel:8773338303">877-333-8303</a> or start your quote online today.
            </p>
        </div>
    );
}
